import { BuilderComponent } from '@builder.io/react';
import PageHead from './Head';
import Footer from './Footer';
import { PageContent } from '@/types';
const BuilderPage = ({
  content
}: {
  content: PageContent;
}) => {
  const {
    isLightMode,
    footer,
    footerBackgroundColor,
    footerTextColor,
    url,
    title,
    description,
    shareImage
  } = content.page?.data || {};
  return <>
			<PageHead path={url || '/'} title={title || ''} description={description || ''} shareImage={shareImage} data-sentry-element="PageHead" data-sentry-source-file="BuilderPage.tsx" />
			<BuilderComponent content={content.page} model="custom-page" options={{
      includeRefs: true
    }} data-sentry-element="BuilderComponent" data-sentry-source-file="BuilderPage.tsx" />
			<Footer isLightMode={isLightMode} copy={footer?.value.data.copy || ''} links={footer?.value.data.links || []} footerBackgroundColor={footerBackgroundColor} footerTextColor={footerTextColor} data-sentry-element="Footer" data-sentry-source-file="BuilderPage.tsx" />
		</>;
};
export default BuilderPage;